import { Component, EventEmitter, Input, OnInit, Output } from "@angular/core";
import { MatDialog } from "@angular/material/dialog";
import { MatSnackBar } from "@angular/material/snack-bar";
import { catchError, map } from "rxjs";
import { BackendListModel } from "src/app/models/common/list.model";
import { DepartmentModel } from "src/app/models/department";
import { ApiRoutes } from "src/app/services/apiroutes";
import { DepartmentApiService } from "src/app/services/domain_code/department-api.service";
import { WarningBoxComponent } from "../../dialog-box/warning-box/warning-box.component";

@Component({
  selector: 'logzy-department-form',
  templateUrl: './department-form.component.html',
  styleUrls: [
    './department-form.component.scss',
    '../master-data.scss',
  ]
})

export class DepartmentFormComponent implements OnInit {

  department_url = ApiRoutes.Company;
  // open: string = "sidepanel";
  // canvas: string = "Canvas";
  clickedDepartmentObj;

  @Input()
  errorObj: any = {};

  @Output()
  closeForm = new EventEmitter<DepartmentModel>();

  @Output()
  onDepartmentCreated = new EventEmitter<DepartmentModel>();

  keysToTransform = [
    'parent',
  ];

  // closeDD() {
  //   // document.getElementById("mySidepanel")!.style.width = "0";
  //   this.open = " sidepanel";
  //   this.canvas = "Canvas";
  //   this.departmentObject = { ...this.defaultDepartment };
  // }

  constructor(private departmentService: DepartmentApiService, private snackBar: MatSnackBar, private dialog: MatDialog) { }

  @Input()
  departmentObject: DepartmentModel;

  defaultDepartment: DepartmentModel = {
    id: null,
    name: null,
    parent: null,
    description: null,
    is_active: true,
    readonly: false,
    active_from: null,
    active_till: null
  }

  ngOnInit() {
    this.resetComponent();
    // this.getAllDepartments();
  }

  resetComponent() {
    this.errorObj = {};
    this.departmentObject = { ...this.defaultDepartment };
  }

  // department_list: BackendListModel<DepartmentModel>;

  // getAllDepartments() {
  //   this.departmentService.getDepartment().subscribe({
  //     next: response => {
  //       console.log("dept ersponse", response)
  //       this.department_list = response;
  //     },
  //     error: error => {
  //       return error
  //     }
  //   });
  // }


  // Function to catch errors
  catchError(error) {
    if (error.status >= 500) {
      this.errorObj = { ...error.error };
      return error;
    } else if (error.status > 399 && error.status < 500) {
      this.errorObj = { ...error.error };
      return error;
    }
  }

  postDepartmentData(data) {
    this.departmentService.postDepartment(data).subscribe({
      next: response => {
        this.snackBar.open("Department Added Successfully!", 'Close', {
          verticalPosition: 'top',
          duration: 2000,
        });
        this.closeDepartmentForm(response);
        return response;
      },
      error: error => {
        return this.catchError(error);
      }
    })
  }

  putDepartmentData(id, data) {
    this.departmentService.updateDepartment(id, data).subscribe({
      next: response => {
        this.snackBar.open("Department Updated Successfully!", 'Close', {
          verticalPosition: 'top',
          duration: 2000,
        });
        this.closeDepartmentForm(response);
        return response;
      },
      error: error => {
        return this.catchError(error);
      }
    })
  }

  filterDepartmentData() {
    let data = { ...this.departmentObject };
    for (const key of this.keysToTransform) {
      if (data[key] != null && data[key] != '')
        data[key] = data[key].id;
    }
    return data;
  }

  onDepartmentSave() {
    let payload;

    if (typeof this.departmentObject.parent == 'object' && this.departmentObject.parent != null) {
      payload = this.filterDepartmentData();
    } else {
      payload = { ...this.departmentObject }
    }
    console.log("dept payload", payload)

    if (payload.id != null) {
      if (payload.is_active == false && payload.children.length) {
        this.clickedDepartmentObj = payload;
        this.openWarningDialog("This is a Parent Department", "Marking this department inactive will set dependent departments' Parent EMPTY.<br>Are you sure to continue?", "Back", "Proceed");
      } else if (payload.is_active == false && !payload.children.length) {
        this.clickedDepartmentObj = payload;
        this.openWarningDialog("Make this department inactive??", "Making Department Inactive will SOFT Delete it, which might impact some features, users are accessing.<br>Do you still want to continue?", "No", "Yes");
      } else {
        this.putDepartmentData(payload.id, payload)
      }
    } else {
      this.postDepartmentData(payload);
    }
    // this.closeDD();
  }

  editDepartmentMaster(element) {
    this.departmentObject = JSON.parse(JSON.stringify(element));
  }

  closeDepartmentForm(departmentObject: DepartmentModel) {
    this.resetComponent();
    this.closeForm.emit(departmentObject);
  }

  lock(item) {
    item.readonly = !item.readonly;
  }

  openWarningDialog(label: string, temp, action1: string, action2?: string) {
    const dialogRef = this.dialog.open(WarningBoxComponent, {
      panelClass: 'dialog-container-custom',
      data: { subTitle: label, parent: this, description: temp, label1: action1, label2: action2, negativeAction: this.negativeResponse, positiveAction: this.positiveResponse }
    })
    dialogRef.afterClosed().subscribe(is_positive => {
      if (is_positive == false || is_positive == undefined) {
        this.departmentObject.is_active = true;
      }
    });
  }

  positiveResponse(parent) {
    parent.putDepartmentData(parent.clickedDepartmentObj.id, parent.clickedDepartmentObj);
  }

  negativeResponse(parent) {
    parent.departmentObject.is_active = true
  }
}